import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-6" }
const _hoisted_5 = { class: "form-group mb-4" }
const _hoisted_6 = { class: "form-group position-relative" }
const _hoisted_7 = {
  key: 0,
  class: "input-error"
}
const _hoisted_8 = { class: "col-lg-6" }
const _hoisted_9 = { class: "form-group mb-4" }
const _hoisted_10 = { class: "form-group position-relative" }
const _hoisted_11 = {
  key: 0,
  class: "input-error"
}
const _hoisted_12 = { class: "col-lg-6" }
const _hoisted_13 = { class: "form-group mb-4" }
const _hoisted_14 = { class: "form-group position-relative" }
const _hoisted_15 = { class: "input-error" }
const _hoisted_16 = { class: "col-lg-6" }
const _hoisted_17 = {
  key: 0,
  class: "form-group mb-4"
}
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "input-error" }
const _hoisted_20 = { class: "col-lg-6" }
const _hoisted_21 = { class: "form-group mb-4 p-4 bg-body d-sm-flex justify-content-between align-items-center rounded-3" }
const _hoisted_22 = { class: "d-sm-flex align-items-center mb-3 mb-sm-0 me-lg-3 position-relative" }
const _hoisted_23 = { class: "position-relative d-inline-block" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "d-flex ms-sm-3 ms-md-0" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-lg-12" }
const _hoisted_28 = { class: "d-flex flex-wrap gap-3" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { key: 0 }
const _hoisted_31 = {
  key: 1,
  class: "spinner-border spinner-border-sm me-2",
  "aria-hidden": "true"
}
const _hoisted_32 = {
  key: 2,
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[22] || (_cache[22] = _createElementVNode("div", { class: "mb-4" }, [
        _createElementVNode("h4", { class: "fs-20 mb-1" }, "Perfil")
      ], -1 /* HOISTED */)),
      _createElementVNode("form", {
        onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.validateForm && _ctx.validateForm(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[12] || (_cache[12] = _createElementVNode("label", { class: "label text-secondary" }, "Nombres", -1 /* HOISTED */)),
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control text-dark ps-5 h-45",
                  placeholder: "Ingrese sus nombres",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.firstName) = $event)),
                  onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearError('firstName')))
                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                  [_vModelText, _ctx.user.firstName]
                ]),
                _cache[11] || (_cache[11] = _createElementVNode("i", { class: "ri-user-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20" }, null, -1 /* HOISTED */)),
                (_ctx.errors.firstName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.errors.firstName), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[14] || (_cache[14] = _createElementVNode("label", { class: "label text-secondary" }, "Apellidos", -1 /* HOISTED */)),
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control text-dark ps-5 h-45",
                  placeholder: "Ingrese sus apellidos",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.lastName) = $event)),
                  onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clearError('lastName')))
                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                  [_vModelText, _ctx.user.lastName]
                ]),
                _cache[13] || (_cache[13] = _createElementVNode("i", { class: "ri-user-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20" }, null, -1 /* HOISTED */)),
                (_ctx.errors.lastName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.errors.lastName), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _cache[16] || (_cache[16] = _createElementVNode("label", { class: "label text-secondary" }, "Username (Correo electrónico)", -1 /* HOISTED */)),
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  class: "form-control text-dark ps-5 h-45",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user.email) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.user.email]
                ]),
                _cache[15] || (_cache[15] = _createElementVNode("i", { class: "ri-mail-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20" }, null, -1 /* HOISTED */)),
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.errors.email), 1 /* TEXT */)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            (_ctx.itemsRoles)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _cache[18] || (_cache[18] = _createElementVNode("label", { class: "label text-secondary" }, "Rol", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("select", {
                    disabled: "",
                    class: "form-select form-control h-45",
                    "aria-label": "Default select example",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.user.idRole) = $event)),
                    onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.clearError('companyId')))
                  }, [
                    _cache[17] || (_cache[17] = _createElementVNode("option", { value: null }, "-- Seleccionar --", -1 /* HOISTED */)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsRoles, (item, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: item.id,
                        key: i
                      }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_18))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                    [_vModelSelect, _ctx.user.idRole]
                  ]),
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.errors.idRole), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "me-md-5 pe-xxl-5 mb-3 mb-sm-0" }, [
                _createElementVNode("h4", { class: "body-font fs-15 fw-semibold text-body" }, "Tu foto")
              ], -1 /* HOISTED */)),
              _createCommentVNode(" Image Container "),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("img", {
                  class: "rounded-4 wh-75 ms-3 ms-lg-0 rounded-circle",
                  src: _ctx.profileUrl,
                  alt: "user",
                  style: {"width":"125px","height":"125px","object-fit":"cover"}
                }, null, 8 /* PROPS */, _hoisted_24),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-light position-absolute bottom-0 end-0 rounded-circle",
                  style: {"transform":"translate(25%, 25%)"},
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.triggerFileInput && _ctx.triggerFileInput(...args)))
                }, _cache[19] || (_cache[19] = [
                  _createElementVNode("span", { class: "material-symbols-outlined" }, "add_a_photo", -1 /* HOISTED */)
                ])),
                _createCommentVNode(" Hidden file input "),
                _createElementVNode("input", {
                  type: "file",
                  ref: "fileInput",
                  accept: "image/*",
                  onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args))),
                  class: "d-none"
                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */)
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("button", {
                type: "button",
                class: "btn bg-danger bg-opacity-10 text-danger fw-semibold",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.resetProfilePhoto && _ctx.resetProfilePhoto(...args)))
              }, " Eliminar ")
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("button", {
                type: "submit",
                disabled: _ctx.isLoading,
                class: "btn btn-primary py-2 px-4 fw-medium fs-16"
              }, [
                (!_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, _cache[21] || (_cache[21] = [
                      _createElementVNode("i", { class: "ri-check-line text-white fw-medium" }, null, -1 /* HOISTED */),
                      _createTextVNode(" Actualizar Perfil")
                    ])))
                  : _createCommentVNode("v-if", true),
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_31))
                  : _createCommentVNode("v-if", true),
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_32, "Procesando..."))
                  : _createCommentVNode("v-if", true)
              ], 8 /* PROPS */, _hoisted_29)
            ])
          ])
        ])
      ], 32 /* NEED_HYDRATION */)
    ])
  ]))
}